import { AbstractControl } from '@angular/forms';

export class ProductCodeValidators {

  static productCodeValidator(codeFormat: RegExp) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const valid = (control.value && control.value.length> 0 &&  control.value[0] != '' && codeFormat) ? codeFormat.test(control.value) : true;
      return valid ? null : { invalidText: true };
    };
  }
}

